import { execute } from '@/api/execute'
import { GET, PUT, POST, DELETE } from '@/api/types'
import { addQueryParams } from '@/util/index.js'

const ENDPOINT = 'dashboard/groups'

export default {
  // Groups endpoints
  list (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/`, params))
  },

  create (payload) {
    return execute(POST, `${ENDPOINT}/`, payload)
  },

  getById (id) {
    return execute(GET, `${ENDPOINT}/${id}/`)
  },

  updateById (id, payload) {
    return execute(PUT, `${ENDPOINT}/${id}/`, payload)
  },

  deleteById (id) {
    return execute(DELETE, `${ENDPOINT}/${id}/`)
  },

  // Statistics endpoints
  getClientScheduleStats (userId, params = {}) {
    return execute(GET, addQueryParams(`dashboard/clients/${userId}/statistics/schedules/`, params))
  },

  getClientFarmStats (userId, params = {}) {
    return execute(GET, addQueryParams(`dashboard/clients/${userId}/statistics/farms/`, params))
  },
  getClientFarmView (userId, params = {}) {
    return execute(GET, addQueryParams(`dashboard/clients/${userId}/view/farms/`, params))
  },

  // Comments endpoints
  getClientComments (userId, params = {}) {
    return execute(GET, addQueryParams(`dashboard/clients/${userId}/comments/list/`, params))
  },

  createClientComment (userId, payload) {
    return execute(POST, `dashboard/clients/${userId}/comments/list/`, payload)
  },
  deleteClientComment (userId, commentId) {
    return execute(DELETE, `dashboard/clients/${userId}/comments/list/${commentId}`)
  }
}
